export default function isThirdPartyDisabled(search?: string): boolean {
  try {
    const params = new URLSearchParams(search ?? window.location.search);
    const value = params.get('disable_tracking');
    if (value === null) return false;
    if (value === '') return true;
    const normalized = value.toLowerCase();
    return (
      normalized === '1' ||
      normalized === 'true' ||
      normalized === 'yes' ||
      normalized === 'on'
    );
  } catch (e) {
    return false;
  }
}
